/**
 * Developer Portal - Knockout to Vue wrapper
 *
 * This bridges the Knockout component system with the Vue-based API documentation.
 * It registers a Knockout component that mounts the Vue ApiDocumentation component.
 */

import Vue from 'vue';
import ko from '@tko/build.knockout';
import ApiDocumentation from './ApiDocumentation.vue';

const template = '<div id="developer-portal-container"></div>';

class DeveloperPortal {
  constructor() {
  }

  koDescendantsComplete() {
    // Mount Vue component after Knockout finishes rendering
    new Vue({
      el: '#developer-portal-container',
      render: h => h(ApiDocumentation)
    });
  }
}

// Self-registering Knockout component
ko.components.register('developer-portal-container-view', {
  template: template,
  viewModel: DeveloperPortal
});
